 <template>
 <div class="photo-view">
    <span v-if="edit">
      <PhotoEdit />
      <PhotoList />
    </span>
    <span v-else>
      <PhotoSingle />
    </span>
 </div>
</template>

<script>
    import { mapState } from 'vuex'
import PhotoSingle from '@/components/image/Single'
import PhotoEdit from '@/components/image/Edit'
import PhotoList from '@/components/image/List'

export default { 
        name: 'Photo',
         components: { 
            PhotoEdit,
            PhotoSingle,
            PhotoList
        },
        props: {
          edit: {
            default: false,
            type: Boolean
          }
        },
        data() {
          return {
            image_id: this.$route.params.image_id
          }
        },
        ...mapState({
                 username: state => state.user.identity.username
            }),
        methods: {
           getImages(params = {}) { 
                if( this.username ) params.user = this.username
                this.loading = true
                this.$store.dispatch('image/getImages', params ).finally(() => (this.loading=false));
            }
        },
        watch: {
            username: function() {
              this.getImages()
            },

        },
        mounted() {
          this.getImages()
        }
}
</script>

<style scoped>

</style>